
export default function VictoriaLicensing() {
  const steps = [
    {
      number: '01',
      title: 'Obtain Provincial Registry Number',
      description: 'First, register with BC\'s Provincial STR Registry. This is mandatory before applying for Victoria city license. Platforms verify registry numbers and automatically de-list properties without valid registration.',
      icon: 'ri-government-line'
    },
    {
      number: '02',
      title: 'Confirm Eligibility',
      description: 'Verify the property is your principal residence (where you live) and meets zoning requirements. Can include one secondary suite or ADU on the same property.',
      icon: 'ri-checkbox-circle-line'
    },
    {
      number: '03',
      title: 'Prepare Fire Safety Plan',
      description: 'Create Fire Safety Plan with visual floor plan showing emergency exits. Ensure certified fire extinguishers are installed. Gather government ID and utility bills.',
      icon: 'ri-shield-check-line'
    },
    {
      number: '04',
      title: 'Gather Documentation',
      description: 'Prepare proof of principal residence (BC ID, utility bills), property ownership documents, Provincial Registry Number, and Fire Safety Plan.',
      icon: 'ri-file-copy-line'
    },
    {
      number: '05',
      title: 'Submit Application',
      description: 'Apply online through the City of Victoria business license portal with all required documents including Provincial Registry Number.',
      icon: 'ri-send-plane-line'
    },
    {
      number: '06',
      title: 'Pay License Fee',
      description: 'Pay the annual $300 business license fee. Licenses are valid for one calendar year.',
      icon: 'ri-bank-card-line'
    },
    {
      number: '07',
      title: 'Display License Numbers',
      description: 'Once approved, display both your Provincial Registry Number and city license number prominently on all booking platform listings.',
      icon: 'ri-price-tag-3-line'
    },
    {
      number: '08',
      title: 'Maintain Compliance',
      description: 'Keep records, collect applicable taxes (MRDT), and renew your license annually before expiration.',
      icon: 'ri-shield-star-line'
    }
  ];

  return (
    <section id="licensing" className="py-24 lg:py-32 bg-[#F8F8F8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-[#882629]/10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
            Licensing Process
          </span>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            How to Get Licensed in Victoria 2026
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Follow these steps to obtain your Provincial Registry Number and Victoria business license. Provincial registration is required first, then city licensing.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step) => (
            <div
              key={step.number}
              className="bg-white rounded-2xl p-8 hover:shadow-lg transition-all relative overflow-hidden"
            >
              <div className="absolute top-4 right-4 text-6xl font-bold text-[#882629]/5">
                {step.number}
              </div>
              <div className="relative z-10">
                <div className="w-12 h-12 bg-[#882629] rounded-xl flex items-center justify-center mb-6">
                  <i className={`${step.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-xl font-semibold text-[#505A5A] mb-3">{step.title}</h3>
                <p className="text-[#505A5A]/70 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-2xl p-8 lg:p-10">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="w-16 h-16 bg-[#882629]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-3xl text-[#882629]"></i>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-[#505A5A] mb-2">2026 Provincial Registry Enforcement</h3>
              <p className="text-[#505A5A]/70 leading-relaxed">
                Victoria actively enforces STR regulations through complaint-based investigations and Provincial Registry monitoring. The Provincial Registry automatically syncs with platforms - properties without valid registry numbers are de-listed within 24 hours. Operating without proper licensing can result in fines starting at $1,000 per day.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
